// Module
var code = `<span class="deck-copy">{{copyRender}}</span>
`;
// Exports
module.exports = code;